import apiClient from "./config";
import { PROJECT_ENDPOINTS, TODO_ENDPOINTS } from "./endpoints";

export const getProjectList = () => apiClient.get(PROJECT_ENDPOINTS.GET_PROJECT_LIST);
export const addProjectList = (project) => apiClient.create(PROJECT_ENDPOINTS.ADD_NEW_PROJECT, project);
export const updateProjectList = (project) => apiClient.put(PROJECT_ENDPOINTS.UPDATE_PROJECT, project);
export const deleteProjectList = (project) => apiClient.delete(PROJECT_ENDPOINTS.DELETE_PROJECT, { headers: { project } });

// Todo Projects
export const getProjects = (project) => apiClient.get(TODO_ENDPOINTS.GET_PROJECTS, project);
export const addNewProject = (project) => apiClient.create(TODO_ENDPOINTS.ADD_NEW_TODO_PROJECT, project);

